import { Map } from 'immutable';
import { v4 } from 'uuid';

export function newNotification(notification) {
  return Map({ ...notification, id: v4() });
}

export function notificationExists({ notification, notifications }) {
  function reduceNotifications(result, item) {
    if (result) return result;

    let same = true;

    for (const key in notification) {
      if (key !== 'keep' && notification.hasOwnProperty(key)) {
        same = item.get(key) === notification[key];
      }
    }

    return same;
  }

  return notifications.reduce(reduceNotifications, false);
}
